export const PRE_CONNECT_ALL: string[] = ["code.jquery.com", "image.intertoys.nl", "connect.getflowbox.com",
    "www.googletagmanager.com","x.klarnacdn.net","eu-library.klarnaservices.com","integrations.etrusted.com",
    "sec.webeyez.com","send.webeyez.com","chat.omnidesk.io","widgets.trustedshops.com",
    "region1.google-analytics.com","static.hotjar.com","analytics.tiktok.com","developers.google.com","dev.visualwebsiteoptimizer.com"];
export const PRE_CONNECT_STLOC: string[] = ["maps.gstatic.com", "maps.googleapis.com"];
export const PRE_CONNECT_HOME: string[] = ["consent.cookiebot.eu"];
export const PRE_CONNECT_PDP: string[] = [""];
export const PRE_CONNECT_PLP: string[] = [""];